const ComponentsLookup = {
  "default-footer": "DefaultFooter6ba521dcD3ec4bea8e137ae33a0ebe22"
}

export default ComponentsLookup;